import { useEffect, useRef } from "react";

interface NombaPaymentModalProps {
    checkoutLink: string;
    onClose: () => void;
}

export function NombaPaymentModal({ checkoutLink, onClose }: NombaPaymentModalProps) {
    const overlayRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Prevent background scroll
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "";
        };
    }, []);

    return (
        <div
            ref={overlayRef}
            onClick={(e) => {
                if (e.target === overlayRef.current) onClose();
            }}
            style={{
                position: "fixed",
                inset: 0,
                zIndex: 9999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
            }}
        >
            <div
                style={{
                    position: "relative",
                    width: "min(500px, 95vw)",
                    height: "min(700px, 90vh)",
                    backgroundColor: "#fff",
                    borderRadius: 12,
                    overflow: "hidden",
                    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
                }}
            >
                <button
                    onClick={onClose}
                    style={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        zIndex: 10,
                        width: 32,
                        height: 32,
                        border: "none",
                        borderRadius: "50%",
                        backgroundColor: "rgba(0,0,0,0.08)",
                        cursor: "pointer",
                        fontSize: 18,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    ✕
                </button>
                <iframe
                    src={checkoutLink}
                    title="Payment"
                    style={{ width: "100%", height: "100%", border: "none" }}
                    allow="payment"
                />
            </div>
        </div>
    );
}